import Typography from './Typography';
import cx from 'classnames';

const TextInput = ({
  label,
  required = false,
  placeholder = 'you@example.com',
  value,
  onChange,
  type = 'text',
  icon,
  variant = 'default',
  center = false,
  multiline = false,
  rows = 3,
  className = '',
  ...props
}) => {
  return (
    <div
      className={cx(
        'content-stretch flex flex-col gap-[6px] items-start relative w-full',
        className,
      )}
      data-name="Container"
      data-node-id="953:33354"
    >
      {/* Label */}
      {label && (
        <div
          className="content-stretch flex flex-col items-start relative shrink-0 w-full"
          data-name="Label"
          data-node-id="953:33355"
        >
          <Typography
            weight="bold"
            className="text-[#0c2340] text-[14px] leading-[20px] w-full"
            data-node-id="953:33356"
          >
            {label}
            {required && <span className="text-[#d84315]"> *</span>}
          </Typography>
        </div>
      )}

      {/* Input Field */}
      <div
        className={cx(
          'content-stretch flex overflow-clip px-[17px] relative rounded-[12px] shrink-0 w-full',
          {
            'items-center justify-center pb-[18px] pt-[17px]': !multiline,
            'items-start pb-[12px] pt-[12px]': multiline,
            'bg-white border border-[#e5e7eb] border-solid shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]':
              variant === 'default',
            'bg-[#F3F4F6] border-0': variant === 'filled',
          },
        )}
        data-name="Input"
        data-node-id="953:33357"
      >
        <div
          className={cx('flex-[1_0_0] min-h-px min-w-px relative flex', {
            'items-center': !multiline,
            'items-start': multiline,
          })}
          data-name="Container"
          data-node-id="953:33358"
        >
          {/* Icon - only show for single-line inputs */}
          {icon && !multiline && (
            <div className="flex items-center justify-center mr-3 shrink-0 text-[#9ca3af]">
              {icon}
            </div>
          )}
          <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex flex-col items-start overflow-clip relative rounded-[inherit] flex-1 min-w-0">
            {multiline ? (
              <textarea
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                rows={rows}
                className={cx(
                  "flex flex-col font-['Montserrat:Regular',sans-serif] font-normal justify-start leading-[24px] relative shrink-0 text-[#0c2340] text-[16px] w-full bg-transparent border-none outline-none resize-none placeholder:text-[#9ca3af] placeholder:leading-[24px] placeholder:whitespace-pre-wrap",
                )}
                data-node-id="953:33359"
                {...props}
              />
            ) : (
              <input
                type={type}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                className={cx(
                  'flex flex-col font-normal justify-center leading-[0] relative shrink-0 text-[#0c2340] text-[16px] w-full bg-transparent border-none outline-none placeholder:text-[#9ca3af] placeholder:leading-[normal] placeholder:whitespace-pre-wrap',
                  {
                    'pl-0': !icon,
                    'text-center': center,
                  },
                )}
                data-node-id="953:33359"
                {...props}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextInput;
